if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.onSubmitHandler = this.onSubmitHandler.bind(this);
				this.form.addEventListener("submit", this.onSubmitHandler);
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton =
					this.querySelector(".product-form__submit") ||
					this.querySelector('[type="submit"]');
				this.submitButton.addEventListener(
					"touchend",
					this.onSubmitButtonActivation.bind(this),
					{ passive: false }
				);
				this.submitButton.addEventListener(
					"click",
					this.onSubmitButtonActivation.bind(this)
				);
				this.submitButton.addEventListener(
					"keydown",
					this.onSubmitButtonActivation.bind(this)
				);
				if (document.querySelector("cart-drawer")) {
					this.submitButton.setAttribute("aria-haspopup", "dialog");
				}

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitButtonActivation(event) {
				if (!this.closest("quick-add-modal")) return;
				if (
					event.type === "keydown" &&
					event.key !== "Enter" &&
					event.key !== " " &&
					event.code !== "Space" &&
					event.key !== "Spacebar" &&
					event.code !== "NumpadEnter"
				) return;
				if (
					this.submitButton.getAttribute("aria-disabled") === "true" ||
					this.submitButton.getAttribute("aria-busy") === "true"
				) return;

				event.preventDefault();
				this.requestSubmitFromButton();
			}

			requestSubmitFromButton() {
				if (
					this.submitButton.getAttribute("aria-disabled") === "true" ||
					this.submitButton.getAttribute("aria-busy") === "true"
				) return;

				const originalButtonType = this.submitButton.getAttribute("type");
				const shouldRestoreType =
					originalButtonType &&
					originalButtonType.toLowerCase() !== "submit";

				if (typeof this.form.requestSubmit === "function") {
					try {
						if (shouldRestoreType) {
							this.submitButton.setAttribute("type", "submit");
						}
						this.form.requestSubmit(this.submitButton);
					} catch (error) {
						console.error(error);
					} finally {
						if (shouldRestoreType) {
							this.submitButton.setAttribute("type", originalButtonType);
						}
					}
				}

				if (this.submitButton.getAttribute("aria-busy") === "true") return;

				let submitEvent;
				try {
					submitEvent =
						typeof SubmitEvent === "function"
							? new SubmitEvent("submit", {
									bubbles: true,
									cancelable: true,
									submitter: this.submitButton,
							  })
							: new Event("submit", { bubbles: true, cancelable: true });
				} catch (error) {
					submitEvent = new Event("submit", { bubbles: true, cancelable: true });
				}

				this.form.dispatchEvent(submitEvent);
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (
					this.submitButton.getAttribute("aria-disabled") === "true" ||
					this.submitButton.getAttribute("aria-busy") === "true"
				) return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-busy", "true");
				this.submitButton.classList.add("loading");

				const announcer = this.announceAddingToCart();
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						this.submitButton.removeAttribute("aria-busy");
						this.clearAddingToCartAnnouncement(announcer);
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			announceAddingToCart() {
				const announcer = document.getElementById("quick-add-announcer");
				const message =
					window.accessibilityStrings && window.accessibilityStrings.addingToCart;

				if (!announcer || !message) return null;

				clearTimeout(this.announcementSetTimeout);
				clearTimeout(this.announcementClearTimeout);
				announcer.textContent = "";
				this.announcementSetTimeout = setTimeout(() => {
					announcer.textContent = message;
				}, 75);

				return announcer;
			}

			clearAddingToCartAnnouncement(announcer) {
				if (!announcer) return;

				clearTimeout(this.announcementClearTimeout);
				this.announcementClearTimeout = setTimeout(() => {
					announcer.textContent = "";
				}, 1800);
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;
				
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
